const initialState = () => {
    return {
        openingUser: '',
        openingTimeStamp: '',
        initialAmountCash: 0,
        totalCustomerSummaries: 0,
        setDetailCustomerSummaries: null,
        totalEmployeeSummaries: 0,
        setDetailEmployeeSummaries: null,
        setDetailEgressSummaries: null,
        totalIncome: null,
    }
}

export default initialState
